import { render, staticRenderFns } from "./button.vue?vue&type=template&id=72a167f3&scoped=true"
import script from "./button.ts?vue&type=script&lang=ts&external"
export * from "./button.ts?vue&type=script&lang=ts&external"
import style0 from "./button.vue?vue&type=style&index=0&id=72a167f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a167f3",
  null
  
)

export default component.exports